import { useEffect, useRef } from 'react';
import { useSiteContent } from '../../lib/siteContent';

export default function Testimonials() {
  const site = useSiteContent();
  const testimonials = site.testimonials?.items?.length ? site.testimonials.items : [
    { quote: 'Booked for my parents in Gurgaon — smooth, premium, and genuinely reassuring.', author: 'Resident, Sector 56, Golf Course Road, Gurgaon' },
  ];
  const heading = site.testimonials?.heading || 'What Our Customers Say';
  const trackRef = useRef(null);
  const animRef = useRef(null);
  const posRef = useRef(0);

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let paused = false;
    const speed = 0.4; // px per frame

    const step = () => {
      if (!paused) {
        posRef.current -= speed;
        // Reset when first set scrolls out
        const halfWidth = track.scrollWidth / 2;
        if (Math.abs(posRef.current) >= halfWidth) posRef.current = 0;
        track.style.transform = `translateX(${posRef.current}px)`;
      }
      animRef.current = requestAnimationFrame(step);
    };

    animRef.current = requestAnimationFrame(step);

    const onEnter = () => { paused = true; };
    const onLeave = () => { paused = false; };
    track.addEventListener('mouseenter', onEnter);
    track.addEventListener('mouseleave', onLeave);

    return () => {
      cancelAnimationFrame(animRef.current);
      track.removeEventListener('mouseenter', onEnter);
      track.removeEventListener('mouseleave', onLeave);
    };
  }, []);

  // Duplicate for seamless loop
  const items = [...testimonials, ...testimonials];

  return (
    <section data-testid="testimonials-section" className="py-12 md:py-16 bg-[#fdfcff] overflow-hidden border-t border-b border-[#673c96]/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#f37721] text-center" style={{ fontFamily: 'Montserrat' }}>
          {heading}
        </p>
      </div>

      <div className="relative">
        {/* Fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#fdfcff] to-transparent z-10" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#fdfcff] to-transparent z-10" />

        <div ref={trackRef} className="flex gap-10 will-change-transform" style={{ width: 'max-content' }}>
          {items.map((t, i) => (
            <div key={i} className="flex items-center gap-3 shrink-0 select-none">
              <span className="text-[#f37721] text-lg leading-none" style={{ fontFamily: 'Georgia, serif' }}>"</span>
              <p className="text-sm text-[#311b52]/80 whitespace-nowrap" style={{ fontFamily: 'Montserrat' }}>
                {t.quote}
              </p>
              <span className="text-xs text-[#673c96]/50 whitespace-nowrap" style={{ fontFamily: 'Montserrat' }}>
                — {t.author}
              </span>
              <span className="text-[#673c96]/15 mx-2">|</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
